import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { constantes } from 'src/app/shared/components/constantes';
import { JwtTokenModel } from 'src/app/shared/models/jwtToken.model';
import { AfiliadoResponseModel } from 'src/app/shared/models/response/afiliadoResponse.model';

@Injectable({
  providedIn: 'root'
})
export class JwtTokenService {
  jwtToken: string;
  jwtModel: JwtTokenModel;

  constructor() {
    this.getLocalToken();
  }

  getLocalToken() {
    const token = localStorage.getItem(constantes.localStorage.jwtToken);
    if (token) {
      this.jwtToken = token;
      this.decodeToken();
      return token;
    }
    return null;
  }

  setToken(token: string) {
    if (token) {
      this.jwtToken = token;
      localStorage.setItem(constantes.localStorage.jwtToken, token);
      this.decodeToken();
    }
  }

  setCurrentUserDefaultt() {
    if (this.jwtModel.isAdmin) {
    } else {
      localStorage.setItem(constantes.localStorage.afiliadoId, this.jwtModel.afiliadoId.toString());
      localStorage.setItem(
        constantes.localStorage.afiliadoNome,
        this.jwtModel.apelidoNomeSocial === ''
          ? this.jwtModel.nome
          : this.jwtModel.apelidoNomeSocial
      );
    }
  }

  setCurrentUserAfiliado(afiliado: AfiliadoResponseModel = null) {
    if (afiliado === null) {
      localStorage.setItem(constantes.localStorage.afiliadoId, this.jwtModel.afiliadoId.toString());
      localStorage.setItem(
        constantes.localStorage.afiliadoNome,
        this.jwtModel.apelidoNomeSocial === ''
          ? this.jwtModel.nome
          : this.jwtModel.apelidoNomeSocial
      );
    } else {
      localStorage.setItem(constantes.localStorage.afiliadoId, afiliado.id.toString());
      localStorage.setItem(constantes.localStorage.dominioLoja, afiliado.loja.dominioLoja);
      localStorage.setItem(
        constantes.localStorage.afiliadoNome,
        afiliado.apelidoNomeSocial === undefined || afiliado.apelidoNomeSocial === ''
          ? afiliado.nomeCompleto
          : afiliado.apelidoNomeSocial
      );
    }
  }

  getIdAfiliado(): number {
    const item = localStorage.getItem(constantes.localStorage.afiliadoId);
    return parseInt(item, 10);
  }

  getNomeAfiliado(): string {
    return localStorage.getItem(constantes.localStorage.afiliadoNome);
  }

  getDominioLoja(): string {
    if (!this.jwtModel?.lojinha) {
      return localStorage.getItem(constantes.localStorage.dominioLoja);
    }
    return this.jwtModel?.lojinha;
  }

  removeToken() {
    this.limparLocalStorage();
    this.jwtToken = this.jwtModel = null;
  }

  limparLocalStorage() {
    localStorage.removeItem(constantes.localStorage.jwtToken);
    localStorage.removeItem(constantes.localStorage.menuAdministrador);
    localStorage.removeItem(constantes.localStorage.menuConsultora);
    localStorage.removeItem(constantes.localStorage.menu);
    localStorage.removeItem(constantes.localStorage.retornarMenuMini);
    localStorage.removeItem(constantes.localStorage.afiliadoId);
    localStorage.removeItem(constantes.localStorage.afiliadoNome);
    localStorage.removeItem(constantes.localStorage.visualizandoLoja);
  }

  visualizandoLoja(): boolean {
    return localStorage.getItem(constantes.localStorage.visualizandoLoja)?.toLowerCase() === 'true';
  }

  decodeToken() {
    if (this.jwtToken) {
      this.jwtModel = {
        ...this.jwtModel,
        ...jwt_decode(this.jwtToken)
      };
      if (this.jwtModel) {
        this.jwtModel.isAdmin = this.jwtModel?.role === 'Administrador';
        this.jwtModel.bloqueado = this.jwtModel?.bloqueado?.toString();
        this.jwtModel.papelAfiliadoId = +this.jwtModel.papelAfiliadoId;
      }
    }
  }

  getDecodeToken(): JwtTokenModel | null {
    if (this.jwtToken) {
      return jwt_decode(this.jwtToken);
    }
    return null;
  }

  isTokenExpired() {
    if (this.jwtModel) {
      return new Date().getTime() / 1000 >= this.jwtModel.exp;
    }
    return false;
  }
}
